/**
 * A presence marker telling the Next middleware whether someone is signed in.
 *
 * Deliberately not a credential: it carries no token and proves nothing. Its
 * only job is to let the server redirect anonymous visitors away from app
 * routes without first shipping them a dashboard shell that immediately
 * disappears. Real authorisation is the Firebase bearer token on every API
 * call, which the backend verifies; forging this cookie gets you an empty
 * screen and a pile of 401s, nothing more.
 */

export const SESSION_COOKIE = "manito.session"

export async function markSignedIn(): Promise<void> {
  try {
    await fetch("/api/session", { method: "POST" })
  } catch {
    // The cookie is a routing nicety. Losing it costs a redirect, not access.
  }
}

export async function markSignedOut(): Promise<void> {
  try {
    await fetch("/api/session", { method: "DELETE" })
  } catch {
    // Same here: the client-side sign-out is what actually matters.
  }
}
